export const checkValuesExist = (value,array2,compareWith) => {
    return array2.find((obj2) => {
        if(obj2[compareWith]){
            return (value || '').toLowerCase() === (obj2[compareWith] || '').toLowerCase();
        }
    });
};
